export const ItemTypes = {
  PASSENGER: 'passenger'
}



// WEBPACK FOOTER //
// ./src/Constants.js